import fetch from "auth/FetchInterceptor";
// import { IDENTITY_ENDPOINT_URL } from 'configs/AppConfig';
import {
  ACCOUNT_LOGIN,
  ACCOUNT_LOGIN_V2,
  CHANGE_PASS_PROFILE,
  FORGOT_PASSWORD,
  GET_ACCOUNT_POS,
  GET_ACCOUNT_STORE,
  GET_ACCOUNT_WORK,
  GET_PROFILE,
  MOBILE_GET_ACCOUNT_SWITCH,
  RESET_PASSWORD,
  SEARCH_BY_ROLES,
  SEARCH_BY_ROLES_REQUEST,
  SIGN_OUT,
  SWITCH_ACCOUNT_API,
  UPDATE_PROFILE,
  VERIFY_ACCOUNT
} from "constants/ApiConstant";
const AuthService = {};

AuthService.getProfileApi = function (data) {
  return fetch.get(GET_PROFILE, data, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.getProfileById = function (id) {
  return fetch.get(`${GET_PROFILE}/${id}`, null, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.login = function (data) {
  return fetch.post(ACCOUNT_LOGIN, data, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

AuthService.signOutApi = function (data) {
  return fetch.post(SIGN_OUT, data, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

AuthService.forgotPassword = function (data) {
  return fetch.post(FORGOT_PASSWORD, data, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

AuthService.resetPassword = function (data) {
  return fetch.post(RESET_PASSWORD, data, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

AuthService.searchByRoles = function (data) {
  return fetch.post(SEARCH_BY_ROLES, data, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.updateProfile = function (data) {
  return fetch.put(UPDATE_PROFILE, data, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};
AuthService.changePassProfile = function (data) {
  return fetch.post(CHANGE_PASS_PROFILE, data, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/User/register",
    method: "post",
    data: data,
  });
};

AuthService.logout = function (data) {
  return fetch({
    url: "/User/logout",
    method: "post",
    data,
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: "/auth/loginInOAuth",
    method: "post",
  });
};

AuthService.searchByRolesRequest = function () {
  return fetch.get(SEARCH_BY_ROLES_REQUEST, null, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.verifyAccount = function (data) {
  return fetch.post(VERIFY_ACCOUNT, data, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.getAccountEmployee = function (phone) {
  return fetch.get(`${GET_ACCOUNT_POS}/${phone}`, null, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.getAccountWork = function (phone) {
  return fetch.get(`${GET_ACCOUNT_WORK}/${phone}`, null, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.getAccountStore = function (data) {
  return fetch.post(GET_ACCOUNT_STORE, data, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.loginEmployee = function (data) {
  return fetch.post(ACCOUNT_LOGIN_V2, data, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

AuthService.getAccountSwitch = function (phone) {
  return fetch.get(`${GET_ACCOUNT_POS}/${phone}`, null, {
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  });
};

AuthService.switchAccountApi = function (data) {
  return fetch.post(SWITCH_ACCOUNT_API, data, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

export default AuthService;
